import { ajax } from './ajax.js';
import { originalModal } from './modal.js';
export const goodsDetail = () => {

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('.in-cart-btn');
    if (!button) return;

    const requestCode = button.dataset.requestCode;
    const currentUri = button.dataset.currentUri;
    const goodsId = button.dataset.cartGoodsId;
    const no = button.dataset.cartNo;
    const commonStockId = button.dataset.cartCommonStockId;
    const optionCode = button.dataset.cartOptionCode;

    const commonBox = button.closest('.common-box');
    const countSelect = commonBox ? commonBox.querySelector('select[name="count"]') : null;
    const count = countSelect ? countSelect.value : null;

    try {
      const payload = {
        'wwwrequestcode': requestCode,
        'current_uri': currentUri,
        [`add${goodsId}`]: 1,
        id: goodsId,
        no: no,
        count: count,
        common_stock_id: commonStockId ?? '',
      };

      // option_no[...] を詰める
      if (optionCode && optionCode !== 'NONE') {
        const optionArray = optionCode.includes('_') ? optionCode.split('_') : [optionCode];
        optionArray.forEach((value, index) => {
          payload[`option_no[${index + 1}]`] = value;
        });
      }

      // goods_text[...] を詰める
      appendGoodsTextToPayload(button, payload);

      const result = await ajax.post('/action/cart.php', payload);

      // console.log('サーバーからのレスポンス:', result);

      // サーバーからの戻り値をセット
      document.querySelectorAll('[data-request-code]').forEach((el) => {
        el.dataset.requestCode = result.requestCode;
      });

      if (result.status === 'success') {
        // alert('カートに追加しました。');
        // カート商品の表示更新
        const item = result.cart;
        if (!item) {
          alert('カート追加に失敗しました。');
        } else {

          renderCartItems(item, '.in-cart-item-list');

          // --- ヘッダーのカート内商品数表示を更新 ---
          let cartCountSpan = document.querySelector('.in-cart');
          const cartIconLi = document.querySelector('li a[href="/cart.php"]')?.parentElement;

          if (!cartCountSpan) {
            // 初回はバッジ要素が存在しないので新規に作成
            cartCountSpan = document.createElement('span');
            cartCountSpan.classList.add('in-cart');
            if (cartIconLi) cartIconLi.insertBefore(cartCountSpan, cartIconLi.firstChild);
          }

          cartCountSpan.textContent = result.count;

          // バッジを表示させるクラス付与（初回用）
          if (cartIconLi && !cartIconLi.classList.contains('added-to-cart')) {
            cartIconLi.classList.add('added-to-cart');
          }
          // --- ヘッダーのカート内商品数表示を更新 END ---

          // 送料無料金額更新
          toggleFreeShippingBox(result.priceDiff);

          // エラー表示を初期化
          const errorContainer = document.querySelector('.error');
          errorContainer.innerHTML = '';

          // フリー入力のinputをクリアする
          document.querySelectorAll('.option-block input[type="text"]').forEach((input) => {
            input.value = '';
          });

          // カートモーダルを開く
          const { openModal, closeModal } = originalModal();
          closeModal(document.getElementById('optionModal'));
          setTimeout(() => {
            openModal(document.getElementById('inCartModal'));
          }, 500);
        }
      } else if (result.status === 'validation-error') {
        // alert('バリデーションエラーが発生しています。');
        const errorMessages = result.errors;
        renderErrorMessages(errorMessages, '.error');
      } else {
        alert('カート追加に失敗しました。');
      }
    } catch (err) {
      console.error('POSTリクエストエラー:', err);
      alert('通信エラーが発生しました。');
    }
  });

  /**
   * goods_text[...](商品テキスト) を payload に追加する
   *  - common_stock_id が空文字 → ページ全体から全部
   *  - 値あり                   → 押下ボタンと同じ .option-item 内だけ
   */
  function appendGoodsTextToPayload(button, payload) {
    const commonStockId = button.dataset.cartCommonStockId ?? '';

    // 取得対象ノードを決定
    const root =
      commonStockId === ''
        ? document // 全部
        : button.closest('.option-item') || button; // ボタン直近の li

    // 該当フィールドを拾う
    root
      .querySelectorAll('input[name^="goods_text["], textarea[name^="goods_text["]')
      .forEach((el) => {
        payload[el.name] = el.value.trim(); // 空でも詰めるなら trim だけで OK
      });
  }

  /**
   * カートモーダル内商品の表示更新
   *
   * @param item
   * @param containerSelector
   */
  function renderCartItems(item, containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Container "${containerSelector}" が見つかりません。`);
      return;
    }

    container.innerHTML = ''; // 初期化

    const id = item.goodsId;
    const name = item.goodsName || '商品名なし';
    const price = item.price?.toLocaleString?.() ?? '0';
    const count = item.count ?? 0;
    const imageUrl = `/php/image/goods/${id}/1.jpg`;

    let optionHTML = '';

    if (item.optionList) {
      for (const index in item.optionList) {
        const text = item.optionList[index];
        if (text?.name && text?.item_name) {
          optionHTML += `<li>${text.name}：${text.item_name}</li>`;
        }
      }
    }
    if (item.textList) {
      for (const index in item.textList) {
        const text = item.textList[index];
        if (text?.name && text?.value) {
          optionHTML += `<li>${text.name}：${text.value}</li>`;
        }
      }
    }

    const html = `
    <li class="item">
        <div class="image">
            <img src="${imageUrl}" alt="">
        </div>
        <div class="text">
            <p class="name">${name}</p>
            <ul class="option">
                ${optionHTML}
            </ul>
            <div class="price-wrap">
                <p class="price">￥<span id="price">${price}</span>(税込)</p>
                <p class="quantity">数量：<span id="quantity">${count}</span>個</p>
            </div>
        </div>
    </li>
`;

    container.insertAdjacentHTML('beforeend', html);
  }

  /**
   * 送料無料更新
   * オプションモーダル部分とヘッダー部分の両方
   *
   * @param priceDiff
   */
  function toggleFreeShippingBox(priceDiff) {
    const freeShippingBox = document.querySelector('.free-shipping-at');
    const diffSpans = document.querySelectorAll('.price-diff'); // 複数取得

    if (diffSpans.length === 0) return;

    // すべての .price-diff 要素の中身を更新
    diffSpans.forEach((span) => {
      span.textContent = priceDiff;
    });

    if (!freeShippingBox) return;

    if (priceDiff == 0 || priceDiff === '0') {
      freeShippingBox.style.display = 'none';
    } else {
      freeShippingBox.style.display = '';
    }
  }

  /**
   * オプションモーダルにエラーメッセージを出力
   *
   * @param messages
   * @param containerSelector
   */
  function renderErrorMessages(messages, containerSelector) {
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.warn(`Container "${containerSelector}" が見つかりません。`);
      return;
    }

    container.innerHTML = ''; // 一旦初期化（必要に応じて）

    messages.forEach((message) => {
      const p = document.createElement('p');
      p.textContent = message;
      container.appendChild(p);
    });
  }
}
